<a [routerLink]="'/' + teamsPath + '/' + menuItem.slug">
  <div class="team-logo team-logo-bg-dark"></div>
  <div class="team-logo team-logo-bg-team"></div>
  <span [innerHTML]="menuItem.title"
        class="team-name team-color3-txt"></span>
</a>

<div class="links">
  <div class="links__social">
    <ng-container *ngFor="let item of team.wpTeam?.social_links">
      <a *ngIf="item.link"
         [href]="item.link"
         class=" team-color3-bg"
         target="_blank">
        <span class="social-icon team-color-bg"></span>
      </a>
    </ng-container>

  </div>
  <a *ngIf="team.wpTeam?.shop"
     [href]="team.wpTeam.shop"
     class="links__shop team-color3-txt"
     target="_blank"
  >
    <amg-image [src]="team.wpTeam?.bag_image?.sizes?.thumbnail.url"
               class="links__shop-icon team-color2-border"></amg-image>
  </a>
</div>
